import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import QuerySpec from './QuerySpec';

export default function EnterpriseAPI() {
  return (
    <div className="space-y-6">
      {/* Endpoint 1 */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-zinc-900/50 border border-zinc-800 rounded-lg overflow-hidden"
      >
        <div className="px-5 py-4 border-b border-zinc-800 flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <span className="px-2.5 py-1 bg-emerald-500/10 text-emerald-400 border border-emerald-500/30 rounded text-[10px] font-bold tracking-widest font-mono">
              POST
            </span>
            <span className="text-sm font-mono text-zinc-300">/api/v1/cohorts/query</span>
          </div>
          <span className="text-[10px] text-zinc-500 uppercase tracking-widest flex items-center gap-1">
            <SafeIcon icon={FiIcons.FiLock} /> Authenticated (Corp Key)
          </span>
        </div>
        
        <div className="p-5 font-mono text-[11px] md:text-xs">
          <div className="text-zinc-600 mb-2">{"// 1. Enterprise submits a differentially private query to the Eduba Cache"}</div>
          <div className="bg-zinc-950 p-4 rounded border border-zinc-800/50 mb-6 overflow-x-auto text-zinc-300 leading-relaxed">
            <span className="text-cyan-400">curl</span> -X POST https://api.bsmc.autos/v1/cohorts/query \<br/>
            {" "}-H <span className="text-amber-400">"Authorization: Bearer corp_sk_live_..."</span> \<br/>
            {" "}-H <span className="text-amber-400">"Content-Type: application/json"</span> \<br/>
            {" "}-d <span className="text-emerald-400">{`'{"signal": "high_intent_purchase", "epsilon": 0.1, "min_confidence": 0.95}'`}</span>
          </div>

          <div className="text-zinc-600 mb-2">{"// 2. The API returns aggregated cohort data + cryptographic provenance"}</div>
          <QuerySpec />
        </div>
      </motion.div>

      {/* Endpoint 2 */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
        className="bg-zinc-900/50 border border-zinc-800 rounded-lg overflow-hidden"
      >
        <div className="px-5 py-4 border-b border-zinc-800 flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <span className="px-2.5 py-1 bg-cyan-500/10 text-cyan-400 border border-cyan-500/30 rounded text-[10px] font-bold tracking-widest font-mono">
              GET
            </span>
            <span className="text-sm font-mono text-zinc-300">/api/v1/medallion/{"{pool_id}"}/provenance</span>
          </div>
        </div>
        <div className="p-5 bg-zinc-950/50">
          <p className="text-xs text-zinc-400 leading-relaxed max-w-3xl">
            Allows corporate compliance officers to verify the <span className="text-amber-400 font-bold">21 CFR Part 11</span> / <span className="text-amber-400 font-bold">GDPR</span> audit trail. Returns the Ed25519 signatures from the Hammurabi Escrow proving user consent and local PII-stripping without ever exposing the underlying user identities.
          </p>
        </div>
      </motion.div>
    </div>
  );
}